import React from "react";
import { Modal } from "components/common";

interface CreditReportConsentModalProps {
  modalOpen: boolean;
  closeModal: () => void;
  onAgree: () => void;
}

export const CreditReportConsentModal: React.FC<CreditReportConsentModalProps> = (props) => {
  const { onAgree, closeModal, modalOpen } = props;
  return (
    <Modal
      isOpen={modalOpen}
      close={closeModal}
      hasCrossContainer={false}
      options={{ showCloseButton: false }}
      materialModalStyle={{ zIndex: 11 }}
    >
      <div className="rounded-md bg-white p-8 mx-6" style={{ maxWidth: 564 }}>
        <h2 className="text-2xl font-bold">Credit Report Consent</h2>
        <div className="mt-4 text-left">
          <p>
            You understand that by clicking on “I agree” button, you are providing “written instructions” to TomoCredit authorizing TomoCredit to obtain information from your personal credit profile from TransUnion. 
          </p>
          <br />
          <p>You authorize TomoCredit to obtain such information solely to confirm your identity and display your credit data to you.</p>
        </div>
        <div className="mt-5 flex space-x-6">
          <button
            type="button"
            className="px-4 py-2 text-white hover:text-white bg-black hover:bg-neutral-600 focus:bg-neutral-700 font-medium hover:font-medium text-center rounded-md"
            onClick={onAgree}
          >
            I agree
          </button>
          <button
            type="button"
            className="px-4 py-2 bg-white hover:bg-neutral-200 active:bg-neutral-300 font-medium hover:font-medium text-center rounded-md"
            onClick={closeModal}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};